import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Trad } from "src/components";

interface IProductsTabNavProps {
    Products: any[];
    SelectedIndex: number;
    OnClick: (index: number) => void;
}

export const _ProductsTabNav: React.FC<IProductsTabNavProps> = ({ Products, SelectedIndex, OnClick }) => {
    return (
        <List dense disablePadding>
            {Products.map((product, index) => (
                <ListItem button component="a" selected={SelectedIndex == index} onClick={() => OnClick(index)} key={product[0].Index}>
                    <ListItemText primary={`${Trad.Trad(product[0].TipoRamo)} - ${Trad.Trad(product[0].TipoProdotto)}`} />
                </ListItem>
            ))}
        </List>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/CompanyProducts/ProductsTabNav.tsx